import { render, staticRenderFns } from "./AddActivity.vue?vue&type=template&id=0840a259&scoped=true"
import script from "./AddActivity.vue?vue&type=script&lang=js"
export * from "./AddActivity.vue?vue&type=script&lang=js"
import style0 from "./AddActivity.vue?vue&type=style&index=0&id=0840a259&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0840a259",
  null
  
)

export default component.exports